// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import zhTW from 'element-ui/lib/locale/lang/zh-TW';
import App from './App';
// 引入路由
import router from './router';
// 引入状态管理
import store from './vuex/store';
// 引入icon
import './assets/icon/iconfont.css'
import vueHashCalendar from 'vue-hash-calendar'
// 引入组件CSS样式
import 'vue-hash-calendar/lib/vue-hash-calendar.css'
import './assets/css/all.css'
// 
import WOW from 'wowjs';
import 'wowjs/css/libs/animate.css'
// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.prototype.$WOW = WOW;
import axios from 'axios';
Vue.prototype.$axios = axios;

Vue.directive('no-swipe', {
    inserted(el, binding) {
      el.addEventListener('touchmove', (event) => {
        const touch = event.touches[0];
        // 判断是否为水平滑动，可以根据阈值调整
        if (Math.abs(touch.clientX - event.changedTouches[0].clientX) > Math.abs(touch.clientY - event.changedTouches[0].clientY)) {
          event.preventDefault();
        }
      }, { passive: false });
    },
    unbind(el) {
      el.removeEventListener('touchmove', (event) => {
        event.preventDefault();
      }, { passive: false });
    },
  });

Vue.config.productionTip = false;
Vue.use(vueHashCalendar)
// 使用element UI
Vue.use(ElementUI, { locale:zhTW });
// 过滤器
import * as custom from './utils/util'

Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})



 
// 设置rem函数
function setRem() {


  var deviceWidth = document.documentElement.clientWidth > 750 ? 750 : document.documentElement.clientWidth;
  document.documentElement.style.fontSize = (deviceWidth / 7.5) + 'px';
}
 
// 初始化设置
setRem();
 
// 添加窗口变动的监听器
window.addEventListener('resize', setRem);

// 路由拦截器
router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title == undefined?'home':to.meta.title
  window.document.keywords = to.meta.keywords == undefined?'home':to.meta.keywords
  window.document.description = to.meta.description == undefined?'home':to.meta.description

        if (to.meta.requireAuth) { 
     
            if (localStorage.getItem("userInfo")=='false' || localStorage.getItem("userInfo")=='' || localStorage.getItem("userInfo")==false) { // 通过vuex state获取当前的user是否存在
           
                next({
                    path: '/index'               
                })
            } else {
                next();
     
            }
        } else {

                next();
         
        }
   
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store, //使用store vuex状态管理
    components: { App },
    template: '<App/>',
    data: {
        // 空的实例放到根组件下，所有的子组件都能调用
        Bus: new Vue()
    }

})


// WEBPACK FOOTER //
// ./src/main.js